export class SideBar {
  constructor(
    sideBars: SideBarData[],
    activeSidebar: SideBarData,
    butonsData: SideBarButton[],
    sideNavOpen: boolean
  ) {
    this.SideBars = sideBars;
    this.ActiveSidebar = activeSidebar;
    this.ButonsData = butonsData;
    this.SideNavOpen = sideNavOpen;
  }
  SideBars: SideBarData[];
  ActiveSidebar: SideBarData;
  ButonsData: SideBarButton[];
  SideNavMode: 'side' | 'over' = 'side';
  SideNavOpen: boolean;
}
export type SideBarData = {
  name: string;
  img: string;
  icon: string;
  data: SideBarButton[];
};
export type SideBarButton = {
  data: SideNavItem;
  options: SideBarButtonOptions;
  icon?: string;
  butons?: SideBarButton[];
};
export type SideNavItem = {
  name: string;
  active?: boolean;
  url?: string;
  overWriteUrl?: string;
  roles?: string[];
  avoidRoles?: string[];
  queryParams?: QueryParms;
  otherUrls?: string[];
  otherUniqueUrls?: string[];
  exact?: boolean;
  appendUrl?: string;
};
export type SideBarButtonOptions = {
  img?: string;
  level?: number;
  dropeable?: boolean;
  expand?: boolean;
  select?: boolean;
};
type QueryParms = {
  [key: string]: string;
};
